import { Product } from '@core/models/piramide/Product';
import { Incompatibilities } from '../Incompatibilities';

export abstract class FuncionCompatilibidadBase<T extends Product, U extends Product> {
  abstract funciones: { [x: string]: (arg1: T, arg2: U) => Incompatibilities | null };
  ejecutar(objetoA: T, objetoB: U): Incompatibilities[] {
    return Object.keys(this.funciones)
      .map((key) => this.funciones[key](objetoA, objetoB))
      .filter((incompatibilidad) => incompatibilidad?.incompatibility);
  }
}
